import { useFormik } from "formik";
import React from "react";
import { interest } from "../../utils/validators/schema";
import { useEffect } from "react";

const Interest = ({ accountingRef, coverRef, setInterest }) => {
  const onSubmit = (values) => {
    setInterest(values);
    accountingRef?.current?.click();
  };

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      enableReinitialize: true,
      initialValues: {
        default_interest_rate: "",
        minimum_interest_rate: "",
        maximum_interest_rate: "",
      },
      validationSchema: interest,
      onSubmit,
      validate: (values) => {
        const errors = {};
        if (
          parseFloat(values?.default_interest_rate) <
          parseFloat(values?.minimum_interest_rate)
        ) {
          errors.minMax = "Default rate cannot be less than minimum rate";
        }
        if (
          parseFloat(values?.default_interest_rate) >
          parseFloat(values?.maximum_interest_rate)
        ) {
          errors.minMax = "Default rate cannot be greater than maximum rate";
        }
        if (
          parseFloat(values?.maximum_interest_rate) <
          parseFloat(values?.minimum_interest_rate)
        ) {
          errors.minMax = "Minimum rate cannot be greater than maximum rate";
        }
        return errors;
      },
    });

  useEffect(() => {
    setInterest(values);
  }, [values]);

  return (
    <form className='row' onSubmit={handleSubmit}>
      <div className='col-md-4 mb-3'>
        <label htmlFor='default_rate'>
          Default rate <span className='text-danger'>*</span>
        </label>
        <input
          type='number'
          className={`form-control ${
            errors?.default_interest_rate &&
            touched?.default_interest_rate &&
            "is-invalid"
          }`}
          name='default_interest_rate'
          id='default_interest_rate'
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder='0.00'
        />
        {errors?.default_interest_rate && touched?.default_interest_rate && (
          <span className='text-danger'>{errors?.default_interest_rate}</span>
        )}
      </div>
      <div className='col-md-4 mb-3'>
        <label htmlFor='default_rate'>
          Minimum rate <span className='text-danger'>*</span>
        </label>
        <input
          type='number'
          className={`form-control ${
            errors?.minimum_interest_rate &&
            touched?.minimum_interest_rate &&
            "is-invalid"
          }`}
          name='minimum_interest_rate'
          id='minimum_interest_rate'
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder='0.00'
        />
        {errors?.minimum_interest_rate && touched?.minimum_interest_rate && (
          <span className='text-danger'>{errors?.minimum_interest_rate}</span>
        )}
      </div>
      <div className='col-md-4 mb-3'>
        <label htmlFor='default_rate'>
          Maximum rate <span className='text-danger'>*</span>
        </label>
        <input
          type='number'
          className={`form-control ${
            errors?.maximum_interest_rate &&
            touched?.maximum_interest_rate &&
            "is-invalid"
          }`}
          name='maximum_interest_rate'
          id='maximum_interest_rate'
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder='0.00'
        />
        {errors?.maximum_interest_rate && touched?.maximum_interest_rate && (
          <span className='text-danger'>{errors?.maximum_interest_rate}</span>
        )}
      </div>
      <div className=''>
        {errors?.minMax &&
          touched?.maximum_interest_rate &&
          touched?.minimum_interest_rate && (
            <p className='alert alert-warning'>{errors?.minMax}</p>
          )}
      </div>
      <div className='mt-4 d-flex justify-content-end'>
        <button
          type='button'
          className='btn btn-info text-white me-3'
          onClick={() => coverRef?.current?.click()}
        >
          <i className='mdi mdi-arrow-left me-1'></i>
          Previous
        </button>
        <button type='submit' className='btn btn-primary text-white '>
          Next <i className='mdi mdi-arrow-right ms-1'></i>
        </button>
      </div>
    </form>
  );
};

export default Interest;
